
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MainService } from 'src/app/services/main/main.service';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
@Component({
    selector: 'app-download',
    templateUrl: './download.component.html',
    styleUrls: ['./download.component.css'],
    providers: [DatePipe]
})
export class DownloadComponent implements OnInit {
    contract_id: any = null;
    contract_info = {
        contract_code: null
    };
    error = 'Invalid link';
    mode = 1;
    queryParamSubscription: Subscription;
    language_preferred: string;
    constructor(private _mainservice: MainService, public activeroute: ActivatedRoute, public DatePipe: DatePipe) {
        this.error = 'Loading..';
    }

    ngOnInit(): void {
        this.queryParamSubscription = this.activeroute.queryParamMap.subscribe(
            (urldata: any) => {
                let params = urldata.params;
                if ((params.ac_tk || params.actk) && (params.contract_id || params.contractId)) {
                    this.contract_id = (params.contract_id || params.contractId);
                    this.language_preferred = params.lang;
                    this.mode = params.mode;
                    this._mainservice.api({ access_token: (params.ac_tk || params.actk), contract_id: (params.contract_id || params.contractId) }, `pf_contract_info_v2`, false)
                        .subscribe((data: any) => {
                            if (data.is_error == 1) {
                                if (data.override_text || data.err) {
                                    this.error = data.override_text || data.err, data.is_error;
                                    this._mainservice.customPopups(data.override_text || data.err, data.is_error);
                                } else {
                                    this._mainservice.flagPopUps(data.flag, data.is_error);
                                }
                            } else {
                                this.contract_info = data.contract_info[0];
                                this.contract_info['access_token'] = (params.ac_tk || params.actk);
                            }
                        });
                } else {
                    this.error = 'Invalid link';
                }
            }
        )
    }
    downloadContract() {
        let time = new Date().getTimezoneOffset();
        let hours = Math.abs(Math.trunc(time / 60));
        let minutes = ("0" + time % 60).slice(-2);
        let user_timezone = '';
        if (time > 0) {
            user_timezone = "-" + hours + minutes;
        } else {
            user_timezone = "+" + hours + minutes;
        }
        let dataParams = {
            access_token: this.contract_info['access_token'],
            contract_id: this.contract_info['contract_id'],
            pf_id: this.contract_info['pf_id'],
            timezone: user_timezone
        };
        this._mainservice.downloadApi(dataParams, `download_contract_pdf?lang=${this.language_preferred}`, 0)
            .subscribe((data: any) => {
            }, (error: any) => {
                console.log(error);
            })
    }
    downloadConsent() {
        let apidata = {
            doctor_name: this.contract_info['doctor_first_name'] + ' ' + this.contract_info['doctor_last_name'],
            doctor_id: this.contract_info['doctor_id'],
            patient_name: this.contract_info['patient_first_name'] + ' ' + this.contract_info['patient_last_name'],
            date: this.DatePipe.transform(this.contract_info['date_added'], 'MM/DD/yyyy'),
            contract_id: this.contract_id,
        };
        this._mainservice.downloadApi(apidata, `download_consent_form?lang=${this.language_preferred}`, 0)
            .subscribe((response) => { });
    }

    ngOnDestroy() {
        this.queryParamSubscription && this.queryParamSubscription.unsubscribe();
    }
}
